import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.33203 13.9998H18.6654M3.33203 13.9998V7.33317C3.33203 3.65127 6.3168 0.666504 9.9987 0.666504C13.6806 0.666504 16.6654 3.65127 16.6654 7.33317V13.9998M7.33203 15.9998V16.6665C7.33203 18.1393 8.52594 19.3332 9.9987 19.3332C11.4715 19.3332 12.6654 18.1393 12.6654 16.6665V15.9998",
  stroke: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BellIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "bell",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})